@if(timeOut()) {
<div class="w-full h-full flex justify-content-center align-items-center">
  <app-timeout></app-timeout>
</div>
} @else if(loading()) {
<div class="w-full h-full flex justify-content-center align-items-center">
  <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
</div>
} @else {
<section class="severity-overview" aria-label="Asset status overview">
  <header class="overview-header">
    <h2>{{"severity_overview_widget.title" | translate}}</h2>
    <span>{{"severity_overview_widget.total" | translate}}: {{ formatCount(totalCount()) }} </span>
  </header>

  <div class="overview-content">
    <div class="chart-shell">
      <canvas
        #severityChart
        aria-label="Assets grouped by severity"
        role="img"
        (mouseleave)="clearHoveredSeverity()"
      ></canvas>
      <div class="chart-center" aria-hidden="true">
        <span class="chart-total" [ngClass]="{'chart-total-small':isLargeTotal()}"
          >{{ formatCount(totalCount()) }}</span
        >
        <span class="chart-label">{{"severity_overview_widget.gate_systems" | translate}}</span>
      </div>
    </div>

    <ul class="severity-list" aria-label="Severity groups">
      @for (severity of severityGroups(); track severity.key) {
      <li
        class="severity-row"
        [ngClass]="{'severity-row-active':isSeverityActive(severity.key), 'severity-row-muted':isSeverityMuted(severity.key) }"
        [attr.aria-describedby]="isSeverityActive(severity.key) ? 'severity-tooltip-' + severity.key : null"
        (mouseenter)="setHoveredSeverity(severity.key)"
        (mouseleave)="clearHoveredSeverity()"
      >
        @if (isSeverityActive(severity.key)) { @if (activeSeverityTooltip(); as tooltipText) {
        <span class="severity-tooltip" [id]="'severity-tooltip-' + severity.key" role="tooltip">
          {{ tooltipText }}
        </span>
        } }
        <span class="status-icon" [style.color]="severity.color" aria-hidden="true">
          @switch (severity.key) { @case ("OK") {
          <svg viewBox="0 0 24 24" focusable="false">
            <path d="M5 12.5 9.2 17 19 7" />
          </svg>
          } @case ("MAJOR") {
          <svg viewBox="0 0 24 24" focusable="false">
            <path d="M12 3 22 20H2Z" />
            <path d="M12 9V14" />
            <path d="M12 17.2V17.4" />
          </svg>
          } @case ("CRITICAL") {
          <svg viewBox="0 0 24 24" focusable="false">
            <path d="M8 3H16L21 8V16L16 21H8L3 16V8Z" />
            <path d="M12 7.5V13" />
            <path d="M12 16.8V17" />
          </svg>
          } @case ("MINOR") {
          <svg viewBox="0 0 24 24" focusable="false">
            <path d="M13 2 5 13H11L9 22 19 10H13Z" />
          </svg>
          } }
        </span>
        <span class="severity-label">{{ "severity_overview_widget." + severity.key | translate }}</span>
        <span class="severity-count">{{ formatCount(severity.count) }}</span>
      </li>
      }
    </ul>
  </div>
</section>
}
